import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { TABLE_PAGINATION_KEY, CIRCUIT_NOT_FOUND, GDPR_CONFIRMATION_MESSAGE, AUDIT_NOTE, ROUTE_LINK_LOCATION } from '../../../../../constants/external-constants';
import LineItemsLayoutComponent from './line-items-layout.component';
import DetailsModal from '../../../../common/modal/details-modal/details-modal';
import ButtonIcon from "../../../../button";
import { invoiceLineItemsActions } from "../../../../../store/external/invoice/invoice/line-items.reducer";
import SublineItemComponent from './subline-item.component';
import { invoiceSubLineActions } from '../../../../../store/external/invoice/subline-item.reducer';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
class LineItems extends Component {
    constructor(props){
        super(props);
        this.state = {
            showModal: false,
            displaySearch: false,
            selectedItem: "",
            auditNote: AUDIT_NOTE.auditNote,
        }
    }
    componentDidMount() {
        const { invoiceDetailsId, getInvoiceLineItems, resizeLineItemsPage } = this.props;
        resizeLineItemsPage(20);
        getInvoiceLineItems(invoiceDetailsId, 0);
    }
    componentWillUnmount() {
        this.props.resetInvoiceLineItems();
    }
    onGetInvoiceLineItems = (pageIndex) => {
        const { invoiceDetailsId, getInvoiceLineItems } = this.props;
        getInvoiceLineItems(invoiceDetailsId, pageIndex);
    }
    onColumnSearchLineItems = () => {
        const { invoiceDetailsId, getInvoiceLineItems } = this.props;
        getInvoiceLineItems(invoiceDetailsId, 0);
    }
    onColumnSortLineItems = (columnClicked, isSortedAsc) => {
        const { invoiceDetailsId, sortInvoiceLineItems } = this.props;
        sortInvoiceLineItems(columnClicked, isSortedAsc, invoiceDetailsId);
    }
    resizePage = (value) => {
        const { invoiceDetailsId, resizeLineItemsPage, getInvoiceLineItems } = this.props;
        resizeLineItemsPage(value);
        getInvoiceLineItems(invoiceDetailsId, 0);
    }
    rowAction = (item, hasLink) => {
        if (hasLink && item.MatchedCircuitCode != CIRCUIT_NOT_FOUND.circuitNotFound && item.IsAudited) {
            window.open(ROUTE_LINK_LOCATION.inventoryCircuitLink + `${item.MatchedCircuitId}`, "_blank")

        }else{
            this.setState({showModal: true, selectedItem: item})
        }
    }

    handleClose = () => {
        this.setState({showModal: false});
    }

    displaySearchField = () =>{
        this.setState({displaySearch:!this.state.displaySearch})
    }

    toLocaleLanguage = (key) => {
            const { locale } = this.props;
            if (locale === null || locale === '' || locale === undefined)
                return translation[translation['defaultLocaleLanguage']][key];
    
            return translation[locale][key];
    }   

    onClickExtractLineItems = () => {
        const { invoiceDetailsId, extractInvoiceLineItems } = this.props;
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            extractInvoiceLineItems(invoiceDetailsId);
        }
    }
    onClickExtractEbill = () => {
        const { invoiceDetailsId, extractEBillData } = this.props;
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            extractEBillData(invoiceDetailsId);
        }
    }
    loading = () => {
        return (
            <NoSubscription />
        );
    }
    render() {
        const { invoiceLineItems, setInvoiceLineItemsColSearchStr, roles } = this.props;
        const { Items } = this.props.invoiceLineItems.invoiceLineItemsItems.Data;
        let IsAudited = Items.length > 0 ? Items[0].IsAudited : false;
        let AuditNote = IsAudited ? "" : this.state.auditNote;
        return (
        
            <>
                {this.state.showModal && (
                    <SublineItemComponent title={"Sub-Line Item - " + this.state.selectedItem.BilledCircuitId}
                        selectedItem={this.state.selectedItem}
                        showModal={this.state.showModal}
                        handleClose={this.handleClose}
                        invoiceNumber={this.props.invoiceNumber}
                        billedCircuitId={this.state.selectedItem.BilledCircuitId}
                        {...roles }
                    />
                    )}

                <LineItemsLayoutComponent 
                    viewSearchAction={this.displaySearchField}
                    extractAction={this.onClickExtractLineItems}
                    extractEBillData={this.onClickExtractEbill}
                    {...roles}
                >
            {this.props.invoiceLineItems.isInvoiceLineItemsLoaded ?

                <TablePagination

                    key={TABLE_PAGINATION_KEY.invoiceInvoice}  
                    classNameWrapper="overflow-auto" 
                    columns={invoiceLineItems.invoiceLineItemsItems.Headers}
                    pageList={invoiceLineItems.invoiceLineItemsItems.Data}
                    pages={invoiceLineItems.invoiceLineItemsItems.Pagination}
                    rowClickAction={(item, hasLink) => { this.rowAction(item, hasLink) }}
                    paginationAction={this.onGetInvoiceLineItems}
                    onColumnClick={this.onColumnSortLineItems}
                    onColumnSearch={() => { this.onColumnSearchLineItems() }}
                    onColumnSearchChange={setInvoiceLineItemsColSearchStr}
                    isColSearchShow={this.state.displaySearch}
                    resizePage={this.resizePage}
                    totalPage={invoiceLineItems.invoiceLineItemsItems.Pagination.TotalEntries}
                />
            : this.loading()}
            {this.props.invoiceLineItems.isInvoiceLineItemsLoaded ?
                        <span className="pending-approval-message">{AuditNote}</span>
                        : ""}  
                    
              </LineItemsLayoutComponent>
            </>
        );
    }
}

export default connect(
    state => {
        const { invoiceLineItems, translation } = state;

        return {
            invoiceLineItems,
            ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceLineItemsActions),
        dispatch
    )
)(LineItems);
